<template>
    <div class="root">
        <section class="filter">
            <div class="route-text-filter">
                <div class="field">
                    <p class="control has-icons-right">
                        <input
                            @input="updateRoutesSearchQuery"
                            class="input is-small"
                            type="text"
                            placeholder="Search (minimum 3 characters)"
                        />
                        <span class="icon is-small is-right">
                            <i class="fas fa-search"></i>
                        </span>
                    </p>
                </div>
            </div>
        </section>
        <section>
            <div v-for="(value, index) in times" :key="`${index}`" class="content">
                <div class="title is-5">{{ value.description }} {{ value.interval }}</div>
                <section class="columns severity high">
                    <div
                        v-for="route in getRoutesInTimeWindow(value.description)"
                        :key="route.id"
                        class="column"
                    >
                        <RouteCard :route="route" :openRoute="openRoute" />
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>
<script>
import RouteCard from '@/widgets/RouteCard'
import { makeSearcher } from '@/utils/searcher'
import { splitBasedOnTime } from '@/views/Dashboard/functions'

const routeSearchPredicate = (query) => {
    const searcher = makeSearcher(query)
    return (route) =>
        searcher.evaluate(
            String(route.id),
            route.courier,
            route.driver.name,
            route.terminalCode,
            String(route.driver.id),
        )
}

export default {
    name: 'Merchant',
    components: {
        RouteCard,
    },
    props: {
        openRoute: Function,
        routes: Array,
        selectedTerminals: Array,
    },
    data: () => ({
        routesSearchQuery: '',
        times: [
            { description: 'Morning', interval: '0-12' },
            { description: 'Afternoon', interval: '12-17' },
            { description: 'Evening', interval: '17-0' },
        ],
    }),
    methods: {
        applyRouteFilter(routes) {
            if (this.routesSearchQuery && this.routesSearchQuery.length > 2) {
                return routes.filter(routeSearchPredicate(this.routesSearchQuery))
            }

            return routes
        },
        updateRoutesSearchQuery(e) {
            this.routesSearchQuery = e.target.value.toLowerCase()
        },
        getRoutesInTimeWindow(time) {
            const { routes, selectedTerminals } = this
            const [morning, afternoon, evening] = splitBasedOnTime(routes, selectedTerminals)
            switch (time) {
                case 'Morning':
                    return this.applyRouteFilter(morning)
                case 'Afternoon':
                    return this.applyRouteFilter(afternoon)
                case 'Evening':
                    return this.applyRouteFilter(evening)
                default:
                    return this.applyRouteFilter(this.routes)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.root {
    padding-left: 20px;
    padding-right: 20px;
}

.filter {
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
}

.route-text-filter {
    min-width: 700px;
}

.severity {
    flex-wrap: wrap;

    .column {
        min-width: 240px;
        max-width: 240px;
    }
}
</style>
